export default __webpack_public_path__ + "static/media/project_main_img.eb19a63e.png";